export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/BF-3a608a42b940d9c6459a78103b8dc752.png";